import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  apiRegistryAll: [],
  apiRegistry: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const ExternalApiRegistrySlice = createSlice({
  name: "apiRegistry",
  initialState,
  reducers: {
    setapiRegistryAll: (state, action) => {
      state.apiRegistryAll = action.payload;
    },
    setapiRegistry: (state, action) => {
      state.apiRegistry = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setapiRegistryAll,
  setapiRegistry,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = ExternalApiRegistrySlice.actions;

export default ExternalApiRegistrySlice.reducer;
